import { render, staticRenderFns } from "./o-our-work-list.vue?vue&type=template&id=10bf94e4"
import script from "./o-our-work-list.vue?vue&type=script&lang=js"
export * from "./o-our-work-list.vue?vue&type=script&lang=js"
import style0 from "./o-our-work-list.vue?vue&type=style&index=0&id=10bf94e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports